export default "__VITE_ASSET__1fcb7355__"